import React, { useState, useContext, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { locations } from "../../data/Data";
import { attendantCheckIn } from "../../api/apiManagement";
import { useForm, Controller, set } from "react-hook-form";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";
import { StaffPortalContext } from "./StaffPortal";
import { LoadingButton } from "@mui/lab";

const ConfirmationPage = () => {
  const {
    register,
    handleSubmit,
    control,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({});

  const { setCurrentStep, data, setData } = useContext(StaffPortalContext);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(0);
  const [completed, setCompleted] = useState(false);

  const matches = useMediaQuery("(max-width:480px)");
  const confirm_Location_operation_hours = locations.find(
    (loc) => loc.value === data?.store
  );
  const { label = "1" } = confirm_Location_operation_hours;

  const back = () => {
    setCurrentStep(1);
  };
  const onSubmit = async () => {
    console.log(data?.phone);

    attendantCheckIn({ phone: data?.phone })
      .then((res) => {
        const currentStatus = res.data.status;
        if (currentStatus === "200") {
          setCompleted(true);
        }
        if (currentStatus === "301") {
          setErrorMessage(301);
        }
        if (currentStatus === "302") {
          setErrorMessage(302);
        }
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Box>
      {completed ? (
        <Box>
          <Typography
            variant="subtitle1"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Confirmation complete!<br></br> 確認完成!
          </Typography>
          <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "20px",
            }}
          >
            <LoadingButton
              variant="outlined"
              sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
              onClick={back}
            >
              Go Back
              <br />
              返回
            </LoadingButton>
          </Box>
        </Box>
      ) : (
        <Box>
          <Typography>
            <Typography
              variant="subtitle1"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              Please confirm the information:<br></br> 請確認提交以下資料：
            </Typography>
            <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: matches ? "column" : "row",
              }}
            >
              <Typography
                variant={matches ? "subtitle2" : "subtitle1"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: matches ? "100%" : "50%",
                  margin: "20px 0",
                }}
              >
                <Box sx={{ width: "160px" }}>
                  Last Name<br></br>
                  姓氏
                </Box>
                <Box sx={{ width: "200px" }}>{data?.lastName}</Box>
              </Typography>
              <Typography
                variant={matches ? "subtitle2" : "subtitle1"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: matches ? "100%" : "50%",
                  margin: "20px 0",
                }}
              >
                <Box sx={{ width: "160px" }}>
                  First Name<br></br>
                  名字
                </Box>
                <Box sx={{ width: "200px" }}>{data?.firstName}</Box>
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: matches ? "column" : "row",
              }}
            >
              <Typography
                variant={matches ? "subtitle2" : "subtitle1"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: matches ? "100%" : "50%",
                  margin: "20px 0",
                }}
              >
                <Box sx={{ width: "160px" }}>
                  Mobile Number
                  <Typography variant="subtitle2">
                    (To receive WhatsApp messages)
                  </Typography>
                  流動電話號碼
                  <Typography variant="subtitle2">
                    (可接收 WhatsApp 訊息)
                  </Typography>
                </Box>
                <Box sx={{ width: "200px" }}>+{data?.phone}</Box>
              </Typography>
              <Typography
                variant={matches ? "subtitle2" : "subtitle1"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: matches ? "100%" : "50%",
                  margin: "20px 0",
                }}
              >
                <Box sx={{ width: "160px" }}>
                  Email Address<br></br>
                  電郵地址
                </Box>
                <Box sx={{ width: "200px" }}>{data?.email}</Box>
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: matches ? "column" : "row",
              }}
            >
              <Typography
                variant={matches ? "subtitle2" : "subtitle1"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: matches ? "100%" : "50%",
                  margin: "20px 0",
                }}
              >
                <Box sx={{ width: "160px" }}>
                  Samsung Experience Store<br></br>
                  三星專門店
                </Box>
                <Box sx={{ width: "200px" }}>
                  <span dangerouslySetInnerHTML={{ __html: label }}></span>
                </Box>
              </Typography>
            </Box>
            <Box
                variant={matches ? "subtitle2" : "subtitle1"}
              sx={{
                display: "flex",
                flexDirection: "row",
                width: matches ? "100%" : "50%",
                margin: "20px 0",
               
              }}
            >
              <Typography sx={{width:"160px"}}>
                Remark: <br />
                備註:
              </Typography>{" "}
              <Box sx={{width:"200px"}}>{data?.remarks}</Box>
            </Box>{" "}
            <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
            <Box sx={{ margin: "20px 0" }}>
              {errorMessage === 301 && (
                <FormHelperText sx={{ textAlign: "center" }} error>
                  No record 沒有資料
                </FormHelperText>
              )}
              {errorMessage === 302 && (
                <FormHelperText sx={{ textAlign: "center" }} error>
                  This customer has redeemed pre-order offer 已使用預訂優惠
                </FormHelperText>
              )}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
              <LoadingButton
                variant="outlined"
                sx={{
                  borderRadius: "30px",
                  lineHeight: "20px",
                  width: "140px",
                }}
                onClick={back}
              >
                Go Back
                <br />
                返回
              </LoadingButton>
              {data?.pre_order == 1 ? (
                <></>
              ) : (
                <LoadingButton
                  variant="outlined"
                  sx={{
                    borderRadius: "30px",
                    lineHeight: "20px",
                    width: "240px",
                  }}
                  onClick={() => onSubmit()}
                >
                  Completed Pre-order
                  <br /> 已使用預訂優惠
                </LoadingButton>
              )}
            </Box>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ConfirmationPage;
